var angular = require('angular');
var Promise = require('bluebird');
var ApplicationAPI = require('../../../common/api').Application;

require('ng-dialog')

 angular
  .module("app.directives")
  .directive('appStats', function(ngDialog){
    return {
      restrict: 'E',
      scope:{
          applicationId: "=",
          displayItems: "@items"
      },
      template: require('./index.pug'),
      replace:true,
      link: function(scope, element, attrs){
        scope.items = [];
        scope.stats = {};
        scope.displayItems = scope.displayItems || ""

        scope.load = function(){
          if (~scope.displayItems.indexOf("matches")) {
            scope.items.push({
              name: 'matches',
              label: 'MATCHES'
            })
          }

          if (~scope.displayItems.indexOf("shortlisted")) {
            scope.items.push({
              name: 'shortlisted',
              label: 'SHORTLIST'
            })
          }

          if (~scope.displayItems.indexOf("offers")) {
            scope.items.push({
              name: 'offers',
              label: 'OFFERS'
            })
          }
        }

        scope.load()

        scope.init = function(){
          ApplicationAPI.GetApplicationStatsOverview(scope.applicationId).then(function(result) {
            scope.stats = result;
            scope.loaded = true;
          })
        }
        scope.init();


        scope.openDialog = function(tab){
          var dialog = ngDialog.open({
            template: require("./dialogs/list.pug")(),
            controller: require("./dialogs/list"),
            plain: true,
            disableAnimation: true,
            className: "ngdialog-theme-default social-count-dialog",
            trapFocus: false,
            resolve: {
              tab: function(){ return tab; },
              applicationId: function(){ return scope.applicationId; },
              items: function(){ return scope.items; }
            }
          });

          dialog.closePromise.then(function(data) {
            // if (data.value.id) {
            //   window.location = "/funders/" + data.value.id + '?fromApplication=' + scope.applicationId;
            // }
          })
        }


      }
    }
  })
